/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiGroupHoursOfOperationRequestGroupHoursFromJSON, StreemApiGroupHoursOfOperationRequestGroupHoursToJSON, } from './';
export function StreemApiCreateGroupHoursOfOperationRequestFromJSON(json) {
    return StreemApiCreateGroupHoursOfOperationRequestFromJSONTyped(json, false);
}
export function StreemApiCreateGroupHoursOfOperationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'workingHoursByDay': !exists(json, 'working_hours_by_day') ? undefined : (json['working_hours_by_day'].map(StreemApiGroupHoursOfOperationRequestGroupHoursFromJSON)),
    };
}
export function StreemApiCreateGroupHoursOfOperationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'working_hours_by_day': value.workingHoursByDay === undefined ? undefined : (value.workingHoursByDay.map(StreemApiGroupHoursOfOperationRequestGroupHoursToJSON)),
    };
}
//# sourceMappingURL=StreemApiCreateGroupHoursOfOperationRequest.js.map